"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactHelmet = _interopRequireDefault(require("react-helmet"));
var _BasicView = _interopRequireDefault(require("./BasicView.js"));
var _EmptyStateGate = _interopRequireDefault(require("../Components/EmptyStateGate.js"));
var _Flex = _interopRequireDefault(require("../Components/Flex.js"));
var _Loader = _interopRequireDefault(require("../Components/Loader.js"));
var _LoadingError = _interopRequireDefault(require("../Components/LoadingError.js"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Loadable view
 *
 * A view default error and loading states.
 * 
 * @package HOPS
 * @subpackage Views
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */class LoadableView extends _react.default.PureComponent {
  /**
   * Render.
   * 
   * @return {ReactNode}
   */
  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_BasicView.default, {
      actions: !this.props.loading && !this.props.error && this.props.actions,
      actionsAlign: this.props.actionsAlign,
      actionsGap: this.props.actionsGap,
      allowHeaderSpaceForActions: this.props.allowHeaderSpaceForActions,
      backLink: this.props.backLink,
      backLinkDisabled: this.props.backLinkDisabled,
      backLinkHidden: this.props.backLinkHidden,
      backLinkLabel: this.props.backLinkLabel,
      breadcrumbs: this.props.breadcrumbs,
      forceHorizontalActions: this.props.forceHorizontalActions,
      hideHeaderWhenPrinting: this.props.hideHeaderWhenPrinting,
      gap: this.props.gap,
      headerContent: this.ready && this.props.headerContent,
      headerContentAboveDivider: this.props.headerContentAboveDivider,
      noDivider: this.props.noDivider,
      title: this.props.title,
      titleExtra: this.props.titleExtra,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
        fullWidth: true,
        gap: this.props.gap,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.default, {
          fullWidth: true,
          gap: this.props.gap,
          mt: this.props.loading && (!this.props.gap || this.props.gap < 2) ? 1 : 0,
          children: this.renderContent()
        }), this.props.footer]
      }), this.props.title && this.props.useHelmet && this.renderHelmet()]
    });
  }

  /**
   * Render content.
   * 
   * @return {ReactNode}
   */
  renderContent() {
    if (this.props.loading) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
      size: 35
    });else if (this.props.error) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadingError.default, {
      message: this.props.errorMessage,
      onRetry: this.props.onRetry
    });else return /*#__PURE__*/(0, _jsxRuntime.jsx)(_EmptyStateGate.default, {
      children: this.props.children
    });
  }

  /**
   * Render the Helmet tags.
   *
   * @return {ReactNode}
   */
  renderHelmet() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHelmet.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("title", {
        children: [this.props.title, " - HOPS"]
      })
    });
  }

  /**
   * Get whether we're ready to render main content.
   * 
   * @return {Boolean} 
   */
  get ready() {
    return !this.props.loading && !this.props.error && !this.props.empty;
  }
}
var _default = exports.default = LoadableView;